import Vue from 'vue';
import UserService from './user.service';

const defaults = {
    item: {
        id: null,
    },
    list: [],
};

const user = {
    namespaced: true,

    state: Object.assign({}, defaults),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(defaults.item)));
            Vue.set(state, 'list', JSON.parse(JSON.stringify(defaults.list)));
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await UserService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            delete client_data.createdAt;
            delete client_data.updatedAt;
            const { data } = await UserService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await UserService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await UserService.query(params);
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            const { data } = await UserService.delete(slug);
            context.commit('updateList', data);
            return data;
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default user;
